import { reverse } from "@reactivated";

import { IAddress } from "../models/address";
import { IShippingMethod, ShippingMethods } from "../models/shipping";
import { check } from "../models/utils";
import { CSRF_HEADER, ajax, getCSRFToken } from "../utils/ajax";
import { PromiseMutex } from "../utils/mutex";

export const loadMethods = async (
    shipping_address: Partial<IAddress>,
): Promise<ReadonlyArray<IShippingMethod>> => {
    const data = {
        line1: shipping_address.line1,
        line2: shipping_address.line2,
        line4: shipping_address.line4,
        state: shipping_address.state,
        postcode: shipping_address.postcode,
        country: shipping_address.country,
    };
    const mutex = new PromiseMutex<ReadonlyArray<IShippingMethod>>(
        `load-shipping-methods-${shipping_address.country}-${shipping_address.state}`,
    );
    let loading = mutex.getPromise();
    if (!loading) {
        loading = ajax
            .get(reverse("checkout-shipping-methods"))
            .set("Accept", "application/json")
            .query(data)
            .then((resp) => {
                return check(ShippingMethods.decode(resp.body));
            });
        mutex.setPromise(loading);
    }
    return loading;
};

export const saveShippingMethod = async (
    shipping_address: Partial<IAddress>,
    methodCode: string,
): Promise<ReadonlyArray<IShippingMethod>> => {
    const data = {
        line1: shipping_address.line1 || "",
        line2: shipping_address.line2 || "",
        line4: shipping_address.line4 || "",
        state: shipping_address.state || "",
        postcode: shipping_address.postcode || "",
        country: shipping_address.country || "",
        shipping_method_code: methodCode,
    };
    return ajax
        .post(reverse("checkout-shipping-methods"))
        .set("Accept", "application/json")
        .set(CSRF_HEADER, await getCSRFToken())
        .send(data)
        .then((resp) => {
            return check(ShippingMethods.decode(resp.body));
        });
};
